import React, {useEffect, useState} from 'react';
import Loader from "./components/Loader";
import Filter from "./components/Filter";
import EventList from "./components/EventList";
import { date, firstDay, lastDay, getEventData } from "./helper";

const G_API = (window as any).__GOOGLE_CALENDAR_API__;

const API_KEY = G_API.API_KEY;
const CALENDAR_ID = G_API.CALENDAR_ID;

function App() {

    const [EventData, setEventData] = useState([]);
    const [FilterData, setFilterData] = useState([firstDay, lastDay]);

    useEffect(() => {
        if(API_KEY && CALENDAR_ID){
            getEventData(FilterData, API_KEY, CALENDAR_ID, setEventData);
        }
    }, [FilterData]);

    return (
        <>
            <div className="filter-wrap">
                <Filter
                    initialSlide={date.getMonth()}
                    setFilterData={setFilterData} />
            </div>
            <div className="events-wrap">
                { EventData.length > 0 ? <EventList {...EventData} /> : <div className="w-100 p-5 text-center"><Loader /></div> }
            </div>
        </>
    );
}

export default App;
